import React from 'react';

export function useFileUpload(onChange: (event: FileList) => void): {
    dropHandler: (ev: React.DragEvent<HTMLLabelElement>) => void;
    dragOverHandler: (ev: React.DragEvent<HTMLLabelElement>) => void;
} {
    const dropHandler = (ev: React.DragEvent<HTMLLabelElement>): void => {
        ev.preventDefault();

        if (ev.dataTransfer.items) {
            const dataTransfer = new DataTransfer();
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    const file = ev.dataTransfer.items[i].getAsFile() as File;
                    dataTransfer.items.add(file);
                }
            }

            onChange(dataTransfer.files);
        } else {
            onChange(ev.dataTransfer.files);
        }
    };

    const dragOverHandler = (ev: React.DragEvent<HTMLLabelElement>): void => {
        ev.preventDefault();
    };

    return {dropHandler, dragOverHandler};
}
